import { IsInt,  IsNotEmpty,  IsOptional,  IsUUID,  Min, ValidateNested } from 'class-validator'
import {  ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { TeachingDto } from '../../teachings'
import { Type } from 'class-transformer'
import { ChapterDto } from '../../chapters/response'

export class ChapterTeachingDto {
  @ApiProperty({ description: 'ID du chapitre', type: 'string' })
  @IsNotEmpty()
  @IsUUID('4')
  id: string

  @ApiProperty({ description: 'ID du chapitre', type: 'string' })
  @IsNotEmpty()
  @IsUUID('4')
  chapterId: string

  @ApiProperty({ description: 'Chapitre', type: () => ChapterDto })
  @IsNotEmpty()
  @ValidateNested()
  @Type(() => ChapterDto)
  chapter: ChapterDto

  @ApiProperty({ description: "ID de l'enseignement", type: 'string', format: 'uuid' })
  @IsNotEmpty()
  @IsUUID('4')
  teachingId: string

  @ApiProperty({ description: 'Teaching', type: () => TeachingDto })
  @IsNotEmpty()
  @ValidateNested()
  @Type(() => TeachingDto)
  teaching: TeachingDto

  @ApiPropertyOptional({ description: 'Numéro d\'ordre', type: Number })
  @IsOptional()
  @IsInt()
  @Min(1)
  orderNumber: number
}
